import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import T from "../../components/T";
import { ChevronLeft, Anchor, Sparkles, Coffee } from "lucide-react";
import { COMFORT } from "../../data/v11Static";

function Section({ icon: Icon, title, items, testid }) {
  return (
    <section className="mt-6" data-testid={testid}>
      <h2 className="font-serif text-2xl flex items-center gap-2">
        <Icon className="w-5 h-5 text-brand" /> {title}
      </h2>
      <ul className="mt-3 space-y-2">
        {items.map((s, i) => (
          <li key={i} className="rounded-2xl bg-card border border-border p-4 text-foreground/85 leading-relaxed">
            {s}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default function ComfortCorner() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const grounding = lang === "es" ? COMFORT.grounding_es : COMFORT.grounding_en;
  const soothe    = lang === "es" ? COMFORT.soothe_es    : COMFORT.soothe_en;
  const activities= lang === "es" ? COMFORT.activities_es: COMFORT.activities_en;

  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-comfort">
        <button onClick={() => navigate("/sanctuary")} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("v11.back_to_sanctuary")}
        </button>
        <p className="font-script text-2xl text-brand">{t("v11.comfort.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight"><T i18nKey="v11.comfort.h" /></h1>
        <p className="mt-3 text-foreground/70 leading-relaxed">{t("v11.comfort.intro")}</p>
      </div>

      <div className="px-8 pb-10">
        <Section icon={Anchor}   title={t("v11.comfort.section_grounding")} items={grounding}  testid="comfort-grounding" />
        <Section icon={Sparkles} title={t("v11.comfort.section_soothe")}    items={soothe}     testid="comfort-soothe" />
        <Section icon={Coffee}   title={t("v11.comfort.section_activities")}items={activities} testid="comfort-activities" />
      </div>
    </AppShell>
  );
}
